<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <b-navbar toggleable="xl" type="dark" variant="dark" fixed="top">
            <b-container>
                <b-navbar-brand @click="goHome();"
                                style="height: 60px">
                    <img src="../assets/logo.png" class="logo">
                    <!--          <i class="icon_search" @click="$router.push('/search?keywords=')"></i>-->
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav v-model="visible">
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto big_nav">
                        <b-navbar-nav>

                            <b-nav-item v-for="(item,index) in menuList" @click="navClick(item)"
                                        :class="{'active':$route.path.indexOf(item.menuUrl) > 0 || (index === 0 && pageNav.menuUrl === '/' && !isProductDetail && !isNewDetail) || (index === 1 && isProductDetail) }"
                                        :key="item.menuId" @mouseleave="navMouseenter(0,item)"
                                        @mouseenter="navMouseenter(1,item)">
                                {{ item.menuNam }}
                            </b-nav-item>

                            <div class="search_nav" id="search_nav" :class="{'active': searchShow}">

                                <div class="search_box" style="display: inline-block" v-if="searchShow">
                                    <b-form-input v-model="searchText" placeholder="Search"
                                                  class="search_input" @keyup.enter="goHome('/search')"></b-form-input>
                                    <img src="../assets/search.png" class="icon_search" @click="goHome('/search')">
                                </div>

                                <i class="icon_search" :class="{'active':searchShow}" @click="searchClick()"></i>
                                <!--                <img :src="searchShow?require('../assets/nav_close.png'):require('../assets/search.png')"-->
                                <!--                     class="icon_search" style="margin-left: 5px;"-->
                                <!--                     @click="searchClick()">-->
                            </div>

                        </b-navbar-nav>

                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none nav-lg" no-caret
                                    class="earth_box">
                            <template v-slot:button-content>
                                <i class="icon_earth"></i>
                                <span class="lang_text">{{ languageText }}</span>
                                <img src="../assets/nav_arrow.png" class="icon_arrow">
                            </template>
                            <b-dropdown-item v-for="item in language" v-if="$route.path.indexOf('/verify') ===-1"
                                             @click="switchLanguage(item)" :key="item.dictValue"
                                             :class="{'active':languageText === item.dictLabel}">
                                {{ item.dictLabel }}
                            </b-dropdown-item>
                        </b-dropdown>

                    </b-navbar-nav>

                    <b-navbar-nav class="ml-auto small_nav" id="small_nav" v-if="menuList.length">

                        <div style="padding: 15px; position: relative">
                            <b-form-input placeholder="search" class="small_nav_search"></b-form-input>
                            <img src="../assets/search.png" class="small_nav_search_icon" @click="goHome('/search')">
                        </div>

                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none nav-lg" no-caret
                                    class="earth_box">
                            <template v-slot:button-content>
                                <i class="icon_earth"></i>
                                <span class="lang_text">{{ languageText }}</span>
                                <img src="../assets/nav_arrow.png" class="icon_arrow">
                            </template>
                            <b-dropdown-item v-for="item in language" v-if="$route.path.indexOf('/verify') ===-1"
                                             @click="switchLanguage(item)" :key="item.dictValue"
                                             :class="{'active':languageText === item.dictLabel}">
                                {{ item.dictLabel }}
                            </b-dropdown-item>
                        </b-dropdown>

                        <div v-for="(item,index) in menuList" v-if="index > 0">
                            <b-button v-b-toggle="'collapse-'+index" variant="primary" class="list"
                                      @click="smallClick(item);"
                                      :class="{'active':$route.path.indexOf(item.menuUrl) > 0 || (index === 0 && pageNav.menuUrl === '/' && !isProductDetail && !isNewDetail) || (index === 1 && isProductDetail) }">
                                {{ item.menuNam }}
                                <img src="../assets/small_arrow.png" width="18" class="right"
                                     v-if="item.children && item.children.length" :class="{'icon_down':item.status1}">
                            </b-button>

                            <!--二级导航-->
                            <b-collapse :visible="index === 0" v-bind:id="'collapse-'+index" class="mt-2"
                                        v-if="item.children && item.children.length">
                                <b-card class="content">
                                    <b-row>
                                        <b-col class="item" cols="6" v-for="item2 in item.children"
                                               :class="{'active':item2.menuChildrenId === menuChildrenId}"
                                               @click="goPage(item2.menuUrl,item2)" v-b-toggle.nav-collapse>
                                            <img :src="api+item2.background" width="28" style="margin-bottom: 8px">
                                            <p class="name">{{ item2.menuNam }}</p>
                                            <p class="dec">{{ item2.menuSubName }}</p>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-collapse>

                        </div>
                    </b-navbar-nav>
                </b-collapse>
            </b-container>
        </b-navbar>

        <transition name="fade">
            <div class="menu-children" ref="menuChildren" @mouseleave="myMouseenter(0)"
                 @mouseenter="myMouseenter(1)">
                <b-container>
                    <b-row class="list">
                        <b-col class="item" :class="{'active':item.menuChildrenId === menuChildrenId}"
                               v-for="(item,index) in menuChildrenList" :key="index" cols="3"
                               @click="goPage(item.menuUrl,item)">
                            <img :src="api+item.background" class="icon">
                            <p class="name">{{ item.menuNam }}</p>
                            <p class="dec">{{ item.menuSubName }}</p>
                        </b-col>
                    </b-row>

                    <div class="more-btn" v-if="curNav.menuUrl==='/products'">
                        <div class="box_inner" @click="goPage(curNav.menuUrl,curNav)">
                            {{ languageNum == 3 ? '查看更多' : 'MORE' }}
                        </div>
                    </div>
                </b-container>
            </div>
        </transition>
    </div>

</template>
<script>

    import {api} from '../api/api';


    let timeout;
    export default {
        name: 'NavBar',
        props: {
            menuList: Array,
            language: Array
        },
        data() {
            return {
                earthStatus: false,
                languageText: '',
                meal: '',
                zIndex: 2,
                showTop: 40,
                hideTop: -1000,
                menuChildrenList: [],
                curNav: {},
                api: api,
                languageNum: window.localStorage.getItem("languageNum"),
                menuChildrenId: '',
                pageNav: {},
                isProductDetail: false,
                isNewDetail: false,
                arrowStatus: false,
                searchShow: false,
                searchText: '',
                visible: false
            }
        },

        methods: {

            // collapseClick() {
            //     console.log(this.visible)
            // },

            smallClick(item) {
                console.log(!item.children || !item.children.length)
                if (!item.children || !item.children.length) {
                    document.body.scrollTop = document.documentElement.scrollTop = 0
                    //设置浏览器title
                    document.title = item.title;
                    this.goHome(item.menuUrl)
                } else {
                    this.$set(item, "status1", !item.status1)
                }
            },

            searchClick() {
                this.searchShow = !this.searchShow;
            },

            goHome(url) {

                if (this.visible) {
                    this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
                }

                let lang = '/zh-hans';

                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }


                if (url === '/search') {
                    this.searchShow = false;
                    this.pageNav = {};
                    this.$router.push(lang + url + '?keywords=' + this.searchText);
                    return;
                }

                if (url) {
                    this.pageNav = {};
                    this.$router.push(lang + url);
                } else {
                    this.pageNav = this.menuList[0];
                    this.$router.push(lang);
                }
            },

            switchLanguage(item) {

                if (this.visible) {
                    this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
                }

                console.log(item)
                window.localStorage.setItem("languageNum", item.dictValue);
                window.localStorage.setItem("languageText", item.dictLabel);

                this.languageNum = item.dictValue;
                this.languageText = item.dictLabel

                let lang = 'zh';

                if (this.languageNum == 1) {
                    lang = 'en';
                } else if (this.languageNum == 2) {
                    lang = 'en-us';
                } else if (this.languageNum == 3) {
                    lang = 'zh-hans';
                } else if (this.languageNum == 4) {
                    lang = 'zh-hant';
                } else if (this.languageNum == 5) {
                    lang = 'de';
                } else if (this.languageNum == 6) {
                    lang = 'fr';
                } else if (this.languageNum == 7) {
                    lang = 'it';
                } else if (this.languageNum == 7) {
                    lang = 'es';
                }

                let pathArr = this.$route.path.split("/")
                pathArr[1] = lang;

                console.log(pathArr.join("/"))
                this.$router.push(pathArr.join("/"));
                this.$router.go(0)
                // setTimeout(() => {
                //     location.reload();
                // })
                // location.reload();
            },

            goPage(url, item) {
                this.pageNav = item;
                let lang = '/zh';

                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }

                document.body.scrollTop = document.documentElement.scrollTop = 0
                //设置浏览器title
                document.title = item.title;

                if (item.description) {
                    document.getElementsByTagName('meta')[1].setAttribute("content", item.description);
                }

                if (item.keywords) {
                    document.getElementsByTagName('meta')[2].setAttribute("content", item.keywords);
                }

                window.localStorage.setItem("curNav", JSON.stringify(item));
                if (item && item.menuChildrenId) {
                    this.menuChildrenId = item.menuChildrenId
                } else {
                    this.menuChildrenId = ''
                }

                this.$refs.menuChildren.style.zIndex = this.zIndex;
                this.$refs.menuChildren.style.top = this.hideTop + "px";

                if (this.curNav.menuUrl === "/products") {
                    if (item.children && item.children.length > 0) {
                        this.$router.push(lang + this.curNav.menuUrl + "?type=" + item.children[0].menuNam)
                    } else {
                        this.$router.push(lang + this.curNav.menuUrl + "?type=" + item.menuNam)
                    }
                    return
                }

                if (url === '') {
                    this.$router.push(lang + "/products?type=" + item.menuNam)
                    return;
                }

                console.log(lang + url);
                this.$router.push(lang + url)
            },

            navClick(item) {
                this.curNav = item;
                if (item.children.length === 0) {
                    this.goPage(item.menuUrl, item)
                } else {
                    this.goPage(item.children[0].menuUrl, item.children[0])
                }
            },

            navMouseenter: function (status, item) {
                this.curNav = item

                if (item.children.length === 0) {
                    return
                }

                this.menuChildrenList = item.children;

                if (status) {
                    if (timeout) {
                        clearTimeout(timeout)
                    }
                    this.$refs.menuChildren.style.top = this.showTop + "px";
                } else {
                    timeout = setTimeout(() => {
                        this.$refs.menuChildren.style.zIndex = this.zIndex;
                        this.$refs.menuChildren.style.top = this.hideTop + "px";
                    }, 100);
                }
            },

            myMouseenter(status) {
                if (timeout) {
                    clearTimeout(timeout)
                }
                if (status) {
                    this.$refs.menuChildren.style.top = this.showTop + "px";
                } else {
                    this.$refs.menuChildren.style.zIndex = this.zIndex;
                    this.$refs.menuChildren.style.top = this.hideTop + "px";
                }
            }
        },
        mounted() {
            document.getElementById("small_nav").style.height = document.documentElement.clientHeight + 'px'
            if (this.$route.name === 'Home' || this.$route.path === '/') {
                this.pageNav = this.menuList[0]
            }

            this.languageText = window.localStorage.getItem("languageText");
            this.isProductDetail = this.$route.name === 'ProductDetail'
            this.isNewDetail = this.$route.name === 'NewDetail'
        },
        watch: {
            // 监听,当路由发生变化的时候执行
            $route(to) {
                this.isProductDetail = to.path === '/product/detail';
                this.isNewDetail = to.path === '/news/about/detail'

                if (this.$route.name === 'Home' || this.$route.path === '/') {
                    this.pageNav = this.menuList[0]
                    document.title = this.pageNav.title;
                } else {
                    this.pageNav = {}
                }

                if (to.name === 'Product') {
                    document.title = to.query.type;
                } else if (to.path === '/product/detail') {
                    return
                }

            },

            visible: function (newVal) {
                if (newVal) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = 'auto'
                }
            }
        },
    }
</script>
<style lang="scss" scoped src="../css/navbar.scss">
</style>